export const environment = {
  production: true,
  baseApiUrl: 'https://api.connectispanel.com/',
  mockBackend: false
};



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/environments/environment.ts